import $ = require("jquery");
import * as GSAP from 'gsap';
import EventEmitter = require("eventemitter3");

abstract class AbstractView {

    public $template: JQuery;
    public emitter: EventEmitter;
    protected static Events: any = {
        ON_TRANSITION_IN_COMPLETE: "onTransitionInComplete",
        ON_TRANSITION_OUT_COMPLETE: "onTransitionOutComplete"
    };

    protected constructor(template: JQuery) {

        this.$template = template;
        this.emitter = new EventEmitter();
        this.init();
    }

    public init(): void {

    }

    public resize(): void {

    }

    public reset(): void {

    }

    public onScroll(top: number): void {

    }

    public update<T>(arg: T): void {

    }

    public updateEvents<T>(arg: T): void {

    }

    public transitionIn(): void {

        this.$template.css("display", "block");
        this.resize();
        GSAP.TweenMax.to(this.$template, 0.3, {
            alpha: 1,
            ease: GSAP.Linear.easeOut,
            onComplete: this.onTransitionComplete.bind(this),
            onCompleteParams: [AbstractView.Events.ON_TRANSITION_IN_COMPLETE]
        });
    }

    public transitionOut(id: number = -1): void {

        GSAP.TweenMax.to(this.$template, 0.3, {
            alpha: 0,
            ease: GSAP.Circ.easeOut,
            onComplete: this.onTransitionComplete.bind(this),
            onCompleteParams: [AbstractView.Events.ON_TRANSITION_OUT_COMPLETE, id]
        });
    }

    public onTransitionComplete(type: string, id?: number): void {

        if (type == AbstractView.Events.ON_TRANSITION_IN_COMPLETE) {

        }
        if (type == AbstractView.Events.ON_TRANSITION_OUT_COMPLETE) {
            this.reset();
            this.$template.css("display", "none");
        }
        this.emitter.emit(type, {
            type: type,
            id: id
        });

    }

}

export = AbstractView;